import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "../Reveal";
import { MoleculeGraph, FloatingShape } from "../Molecules";
import { TECH_FEATURES } from "../../data";

export default function Technology() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [80, -80]);

  return (
    <section
      id="technology"
      ref={ref}
      data-testid="technology-section"
      className="relative bg-[#FAFAFA] py-28 lg:py-40 overflow-hidden"
    >
      <motion.div
        style={{ y }}
        className="absolute -top-10 right-[-4%] opacity-[0.18] pointer-events-none"
      >
        <FloatingShape duration={14}>
          <MoleculeGraph className="w-[420px] h-[420px]" stroke="#0033CC" />
        </FloatingShape>
      </motion.div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>The platform</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-zinc-900 mt-6 leading-tight">
              One integrated engine for genetic medicine.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-body text-base lg:text-lg leading-relaxed text-zinc-600 mt-6">
              Four tightly-coupled capabilities form a closed loop — from discovering a
              target to delivering a therapy — each feeding data back into the next.
            </p>
          </Reveal>
        </div>

        {/* technical exposed-skeleton grid */}
        <div className="grid sm:grid-cols-2 mt-16 border-t border-l border-black/10">
          {TECH_FEATURES.map((f, i) => (
            <Reveal key={f.index} delay={i * 0.08}>
              <div className="group relative border-b border-r border-black/10 p-8 lg:p-12 bg-[#FAFAFA] hover:bg-white transition-colors duration-300 h-full">
                <span className="font-mono text-xs tracking-widest text-brand">
                  {f.index}
                </span>
                <h3 className="font-heading text-xl lg:text-2xl font-medium text-zinc-900 mt-5">
                  {f.title}
                </h3>
                <p className="font-body text-base leading-relaxed text-zinc-600 mt-4 max-w-md">
                  {f.body}
                </p>
                <div className="absolute left-0 bottom-0 h-0.5 w-0 bg-brand group-hover:w-full transition-all duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
